module.exports = __webpack_public_path__ + "img/img2.46f33e6e.png";